module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight tabBox",
    attrs: {
      "id": "faultAlarmOilLow"
    }
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "alarm_process_icon"
  }, [_c('ul', [_c('li', {
    class: {
      active: _vm.stepOneActive, 'finish': !_vm.stepOneActive && _vm.stepOneStatus
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-jibenxinxi"
  }), _c('span', [_vm._v("基本信息")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.stepTwoActive, 'finish': !_vm.stepTwoActive && _vm.stepTwoStatus
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-baojingfangshi"
  }), _c('span', [_vm._v("报警方式")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.stepThreeActive, 'finish': !_vm.stepThreeActive && _vm.stepThreeStatus
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-jiankongquyu"
  }), _c('span', [_vm._v("报警指标")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.stepFourActive, 'finish': !_vm.stepFourActive && _vm.stepFourStatus
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-jiankongcheliang"
  }), _c('span', [_vm._v("监控车辆")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.stepFiveActive
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-wancheng"
  }), _c('span', [_vm._v("完成")])])])])])]), _vm._v(" "), _c('div', {
    style: ({
      display: _vm.stepOneActive ? 'block' : 'none'
    })
  }, [_c('AlarmPlanBase', {
    attrs: {
      "imageData": _vm.imgdata,
      "title": "油量低水平报警",
      "systemAlarms": "当车辆驶出当前的驻防范围时，触发系统报警。",
      "bgClass": "alarm_list_bg02"
    },
    model: {
      value: (_vm.alarmBaseInfo),
      callback: function($$v) {
        _vm.alarmBaseInfo = $$v
      },
      expression: "alarmBaseInfo"
    }
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      display: _vm.stepTwoActive ? 'block' : 'none'
    })
  }, [_c('AlarmPlanMode', {
    attrs: {
      "parentid": _vm.pageid
    },
    model: {
      value: (_vm.alarmModeInfo),
      callback: function($$v) {
        _vm.alarmModeInfo = $$v
      },
      expression: "alarmModeInfo"
    }
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      display: _vm.stepThreeActive ? 'block' : 'none'
    })
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "form-inline grey_box ofh pt10px",
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "form-group pt5px"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "9px"
    }
  }, [_vm._v("车辆剩余油量低于")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input-number', {
    attrs: {
      "min": 1,
      "max": 99,
      "controls": false,
      "inputWidth": 160
    },
    model: {
      value: (_vm.alarmThreshold.promote),
      callback: function($$v) {
        _vm.$set(_vm.alarmThreshold, "promote", $$v)
      },
      expression: "alarmThreshold.promote"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "9px"
    }
  }, [_vm._v("升或者低于")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "width": "150px",
      "padding-left": "9px"
    }
  }, [_c('input-number', {
    attrs: {
      "min": 1,
      "max": 99,
      "controls": false,
      "inputWidth": 160
    },
    model: {
      value: (_vm.alarmThreshold.percentum),
      callback: function($$v) {
        _vm.$set(_vm.alarmThreshold, "percentum", $$v)
      },
      expression: "alarmThreshold.percentum"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("%时，触发报警")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_vm._v("注：升数和百分比同时填写时，则满足任意条件时，将触发报警")])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-inline grey_box ofh pt10px",
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "col-sm-10"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input-number', {
    attrs: {
      "min": 1,
      "max": 9999,
      "controls": false,
      "inputWidth": 90
    },
    model: {
      value: (_vm.alarmThreshold.alarmMinuteCount),
      callback: function($$v) {
        _vm.$set(_vm.alarmThreshold, "alarmMinuteCount", $$v)
      },
      expression: "alarmThreshold.alarmMinuteCount"
    }
  })], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "0"
    },
    model: {
      value: (_vm.alarmThreshold.alarmLimitMode),
      callback: function($$v) {
        _vm.$set(_vm.alarmThreshold, "alarmLimitMode", $$v)
      },
      expression: "alarmThreshold.alarmLimitMode"
    }
  }, [_vm._v("不限")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "1"
    },
    model: {
      value: (_vm.alarmThreshold.alarmLimitMode),
      callback: function($$v) {
        _vm.$set(_vm.alarmThreshold, "alarmLimitMode", $$v)
      },
      expression: "alarmThreshold.alarmLimitMode"
    }
  }, [_vm._v("限制为")])], 1)]), _vm._v(" "), _c('input-number', {
    attrs: {
      "min": 1,
      "max": 99,
      "controls": false,
      "inputWidth": 90,
      "disabled": _vm.alarmOilLowStatus
    },
    model: {
      value: (_vm.alarmThreshold.alarmLimitNum),
      callback: function($$v) {
        _vm.$set(_vm.alarmThreshold, "alarmLimitNum", $$v)
      },
      expression: "alarmThreshold.alarmLimitNum"
    }
  }), _vm._v(" "), _vm._m(4)], 1)])]), _vm._v(" "), _c('div', {
    style: ({
      display: _vm.stepFourActive ? 'block' : 'none'
    })
  }, [_c('AlarmPlanMonitor', {
    attrs: {
      "typeid": _vm.typeid
    },
    model: {
      value: (_vm.alarmMonitorInfo),
      callback: function($$v) {
        _vm.alarmMonitorInfo = $$v
      },
      expression: "alarmMonitorInfo"
    }
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      display: _vm.stepFiveActive ? 'block' : 'none'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center pt10px"
  }, [(_vm.preBtnStatus) ? _c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.preStep
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), (_vm.nextBtnStatus) ? _c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("下一步")]) : _vm._e(), _vm._v(" "), (_vm.finishBtnStatus) ? _c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("完成")]) : _vm._e()])]), _vm._v(" "), _c('tab-modal', {
    ref: "modalMsg",
    attrs: {
      "size": "small",
      "scroll": _vm.scrollTop,
      "title": "提示"
    },
    on: {
      "cancel": _vm.closeModalMsg
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.messageStr) + "\n\t\t\t\t"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeModalMsg
    }
  }, [_vm._v("确定")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 "
  }, [_c('div', {
    staticClass: "module_title"
  }, [_c('span', {
    staticClass: "focus_color"
  }, [_vm._v("请设置报警指标")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group pt5px"
  }, [_c('label', {
    staticClass: "focus_color",
    staticStyle: {
      "padding-left": "17px"
    }
  }, [_vm._v("报警频度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group pl15px"
  }, [_c('span', [_vm._v("每")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group mr30px"
  }, [_c('span', [_vm._v("分钟发送")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v("次报警")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_vm._v("注：系统允许的最高频度为每1分钟发送1次报警，超出部分无效。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f514e4a8","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/vehiclealarm/faultalarm/PageFaultAlarmOilLow.vue
// module id = 1652
// module chunks = 0